export const actions = {
  setWorkflow: 'SET_CURRENT_WORKFLOW',
  enterPassword: 'ENTER_PASSWORD'
};

export const setWorkflow = workflowData => (dispatch) => {
  dispatch({
    type: actions.setWorkflow,
    payload: workflowData
  });
};

export const enterPassword = () => (dispatch) => {
  dispatch({
    type: actions.enterPassword
  });
};



// WEBPACK FOOTER //
// ./src/actions/workflow.js